import {Component} from "@angular/core";
import {AlertController, LoadingController, NavController, NavParams} from "ionic-angular";
import {MenuService} from "../../app/services/menu.service";
import {Menu} from "../../app/classes/menu";
import {MenuViewPage} from "../menuview/menuview";
import {CartService} from "../../app/services/cart.service";
import {AnalyticsService} from "../../app/services/analytics.service";
import { Dialog } from '@capacitor/dialog';
import {API} from "../../app/services/api.service";
import {Customer} from "../../app/classes/customer";
import {Http} from "@angular/http";

@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html',
  providers: [MenuService, MenuViewPage, CartService]
})
export class MenuPage {
  public menus: any = { cards: [], listItems: [], loaded: false };
  public messages: any[] = [];
  public info: any = { closed: true, opened: false, delivery: false, pickup: true};
  public hasError = false;
  private isLoading: boolean = false;

  constructor(public loadingCtrl: LoadingController, private api: API, private analytics: AnalyticsService, private menuService: MenuService,
              public navCtrl: NavController,
              public http: Http,
              public alertCtrl: AlertController,
              public navParams: NavParams) {

    this.isLoading = true;
    Customer.cachedOrCreate(this.http) as Customer;
    menuService.getMenus()
      .subscribe(
        menus => this.setMenus(menus),
        error => this.handleError(error));

    setInterval(() => {
      this.checkMessages();
    }, 10000);

    this.checkMessages();
    this.checkIsOpen();
    setInterval(() => {
      this.checkIsOpen();
    }, 10000);
  }

  checkMessages() {
    const messageData = this.api.getMessages();
    messageData
      .subscribe(
        messages => this.setMessages(messages),
        error => console.error(error));
  }

  checkIsOpen() {
    const openMessage = this.api.isOpen();
    openMessage.subscribe(
      payload => this.setIsOpen(payload),
      error => console.error(error)
    );
  }

  setIsOpen(payload) {
    this.info = payload;
  }

  setMessages(messages) {
    this.messages = messages;
  }

  ionViewDidLoad() {
    this.analytics.trackView("Menu");
  }


  handleError(err: any) {
    this.isLoading = false;
    this.menus.loaded = false;
    this.hasError = true;
    console.error(err);
    if (Dialog)
      Dialog.alert({
        message: "Fehler beim Abrufen der Kategorien, bitte versuche es später noch einmal.",
        title: "Fehler"
      });
  }

  retry() {
    this.isLoading = true;
    this.hasError = false;
    this.menuService.getMenus()
      .subscribe(
        menus => this.setMenus(menus),
        error => this.handleError(<any>error));
  }

  setMenus(menus) {
    const sortedMenus = {
      'cards': menus.filter(menu => !!menu.image),
      'listItems': menus.filter(menu => !menu.image),
      'loaded': true
    };

    this.menus = sortedMenus;
    this.isLoading = false;
  }

  viewMenu(_: Event, menu: Menu) {
    this.navCtrl.push(MenuViewPage, {menu});
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts